
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form/[nonprofit-slug]",
      function () {
        return require("private-next-pages/form/[nonprofit-slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form/[nonprofit-slug]"])
      });
    }
  